import httpSvc from './HttpSvc'
import { DS_ROUTES } from '@/core/constants'

export async function emailNotificationSignup(data) {
  return httpSvc.post(DS_ROUTES.purple_ribbon_awards_signup_add, data)
}

export async function isEmailSignedUpForNotification(email) {
  const resp = await httpSvc.post(DS_ROUTES.purple_ribbon_awards_signup_exists, { email })
  return resp.data.email_available
}
